import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import IdebItem from './IdebItem';
import styles from './IdebTable.scss';
const rootClassName = styles.rootClassName;

class IdebTable extends Component {
  allowEditButton() {
    return this.props.auth.userPermissions.escolas.ideb.edit ? true : false;
  }

  render() {
    return (
      <div
        className={getMergedClassNames([
          rootClassName,
          typeof this.props.className === 'string' ? this.props.className : '',
        ])}
      >
        <Table className={rootClassName + '-table'}>
          <TableHead>
            <TableRow>
              {this.allowEditButton() ? (
                <TableCell
                  className={
                    rootClassName + '-cell ' + rootClassName + '-edit-cell'
                  }
                ></TableCell>
              ) : null}
              <TableCell className={rootClassName + '-cell'}>
                {this.props.languageValues.cadastroIdebAno}
              </TableCell>
              <TableCell className={rootClassName + '-cell'}>
                {this.props.languageValues.cadastroIdebMedia}
              </TableCell>
              <TableCell className={rootClassName + '-cell'}>
                {this.props.languageValues.cadastroIdebMeta}
              </TableCell>
              <TableCell
                className={
                  rootClassName + '-cell ' + rootClassName + '-toggle-cell'
                }
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.idebs.map((ideb, index) => {
              return (
                <IdebItem
                  id={this.props.id + '-' + index}
                  ideb={ideb}
                  key={index}
                  savedCallback={this.props.savedCallback}
                />
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  auth: state.auth,
});

IdebTable.propTypes = {
  id: PropTypes.string,
  idebs: PropTypes.array.isRequired,
  className: PropTypes.string,
  savedCallback: PropTypes.func,
};

export default connect(mapStateToProps)(withRouter(IdebTable));
